import { application } from "./application.js"
import BarChartController from "./bar_chart_controller.js"

application.register('bar-chart', BarChartController)
